import { episodeManager } from '../helpers/managers';
import { post, patch, del } from '../helpers/fetchSagaAPI';
const {
  episodePropsTransformer,
  assignEpisodeOldProps,
} = require('../../server/scripts/dataTransition');

export const updateEpisodeMetadata = (episodeId, meta) =>
  episodeManager.update(episodeId, meta);

export const arrangeEpisodesOrder = episodes => {
  // get the lowest index of the current episode batch
  // and add it to the total length - 1 of the current list
  // use it as the last index for the last item in the list
  const episodeIndexes = episodes.map(({ index = 0 }) => Number(index));
  const lowestIndex = Math.min(...episodeIndexes);
  const lastIndex = lowestIndex + (episodes.length - 1);
  return episodes.reduce((prev, curr, i) => {
    const index = lastIndex - i;
    prev[curr.id] = { index };
    return prev;
  }, {});
};

export const episodeActionPayloadTransformer = ({ soundcastId }, episode, overwrite = false) => {
  const { episodeId } = episode;
  const transitioned = episodePropsTransformer(episode, true);
  return {
    soundcastId,
    episodes: {
      [episodeId]: {
        localData: true,
        ...episode,
        ...assignEpisodeOldProps(transitioned),
      },
    },
    overwrite,
  };
};

export const updateEpisodesOrder = function* (soundcast, indexes) {
  const { id: soundcastId } = soundcast;
  yield patch(`/api/soundcast/${soundcastId}/episodes/order`, {
    indexes,
  });
};

export const deleteEpisode = function* (payload, cancellable = true) {
  const { soundcastId, episodeId } = payload;
  return yield del(`/api/soundcast/${soundcastId}/episode/${episodeId}`, {}, cancellable);
};

export const deleteEpisodes = function* (payload) {
  return yield post('/api/bulk/delete/episodes', { ...payload });
};

export const bulkEpisodes = function* (action, payload) {
  return yield post(`/api/bulk/${action}/episodes`, { ...payload });
};
